import { render, staticRenderFns } from "./TasksHRM.vue?vue&type=template&id=820dc48c&"
import script from "./TasksHRM.vue?vue&type=script&lang=js&"
export * from "./TasksHRM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports